var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdvertisment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 21,
    fill: "#1E1E1E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Category",
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    transform: "translate(-35 -913)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Dashboard/Nav/Vertical"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard/Nav/Vertical/Background"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 280,
    height: 1187,
    transform: "translate(-34 -913)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "items"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 2608791"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.4 6.17647V13.5882C22.44 13.5882 24 11.9824 24 9.88235C24 7.78235 22.44 6.17647 20.4 6.17647ZM10.8 4.94118H2.4C1.08 4.94118 0 6.05294 0 7.41176V12.3529C0 13.7118 1.08 14.8235 2.4 14.8235H3.6V18.5294C3.6 19.8882 4.68 21 6 21H8.4V14.8235H10.8L15.6 19.7647H18V0H15.6L10.8 4.94118Z",
    fill: "#CDD2D7"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "white",
    transform: "translate(-35 -913)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvertisment);
export default __webpack_public_path__ + "static/media/advertisment.55fe94c0bcca3b311b50b413639d8838.svg";
export { ForwardRef as ReactComponent };